import { Extent } from '../model/Extent.js';
import { LayerOptions } from '../model/LayerOptions.js';
import { DataType } from '../model/DataType.js';
import Listener from '../shared/utils/Listener.js';
import { PopupUtils } from '../shared/utils/PopupUtils.js';

export abstract class AbstractLayer extends Listener {
  protected _id!: string;
  constructor() {
    super();
  }

  /**
   *
   * @param visible Set the visibility of the layer
   */
  public abstract setVisible(visible: boolean): AbstractLayer;

  /**
   * Check if the layer is visible
   */
  public abstract isVisible(): boolean;

  /**
   * Get the extent of the layer
   */
  public abstract getExtent(): Extent;

  /**
   * Get the layer options
   */
  public abstract getOptions(): LayerOptions;

  /**
   * Set the data of the layer.
   * @param data - GeoJSON string/object, or Galigeo service URL (when dataType is GALIGEO_SERVICE)
   * @param dataType - Type of data source (default: GEOJSON)
   * @param token - Optional authentication token for Galigeo services
   * @param layerId - Optional layer ID for Galigeo services (required when dataType is GALIGEO_SERVICE)
   */
  public abstract setData(data: any, dataType?: DataType, token?: string, layerId?: string): void;

  /**
   * Get the data of the layer
   */
  public abstract getData(): any;

  /**
   * Filter the features of the layer based on a predicate function.
   * @param predicate
   */
  public abstract setFilter(predicate: (properties: any) => boolean): void;

  /**
   * Move a feature to a new location
   * @param propName Name of the property that identifies the feature
   * @param propValue Value of the property that identifies the feature
   * @param coordinates New coordinates of the feature
   */
  public abstract moveFeature(propName: string, propValue: any, coordinates: number[]): void;

  /**
   * Get the source ID of the layer
   */
  public abstract getSourceId(): string;

  /**
   * Get the popup content template
   */
  public abstract getPopupContent(): string | undefined;

  /**
   * Get the tooltip content template
   */
  public abstract getTooltipContent(): string | undefined;

  public getId(): string {
    return this._id;
  }

  public closePopup(): void {
    PopupUtils.closePopup();
  }
}
